export default __webpack_public_path__ + "static/media/pursuit_icon_outline.16ed3ccf.svg";